import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { formatError } from '../lib/api';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back');
      navigate('/');
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-pattern bg-[#F4F4F5] grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 border-r border-zinc-200 bg-white/80 backdrop-blur">
        <div>
          <div className="font-display font-black text-3xl tracking-tighter leading-none">SYNC/GRID</div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 mt-1">TASK CONTROL SYSTEM</div>
        </div>
        <div className="max-w-md">
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#002FA7] mb-4">OPERATIONS / v1</div>
          <h1 className="font-display text-5xl font-black leading-none tracking-tighter mb-6">
            Daily updates.<br />Zero blind spots.
          </h1>
          <p className="text-base text-zinc-700 leading-relaxed">
            Your boss assigns tasks. You report progress every day, right through to resolved. Every question, every answer — one clean thread.
          </p>
        </div>
        <div className="text-[10px] font-mono text-zinc-500">
          // BOSSES · MANAGERS · EMPLOYEES
        </div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-md bg-white border border-zinc-900 shadow-brutal p-8">
          <div className="mb-8">
            <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500">ACCESS</div>
            <h2 className="font-display text-4xl font-black tracking-tighter">Sign in</h2>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 block mb-2">Email</label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-zinc-300 focus:border-[#002FA7] outline-none px-3 py-3 bg-white"
                placeholder="you@company.com"
              />
            </div>
            <div>
              <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 block mb-2">Password</label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-zinc-300 focus:border-[#002FA7] outline-none px-3 py-3 bg-white"
                placeholder="••••••••"
              />
            </div>
            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#002FA7] text-white py-3 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#002088] disabled:opacity-60 transition-colors"
            >
              {loading ? 'Signing in...' : 'Sign In →'}
            </button>
          </form>
          <div className="mt-6 pt-6 border-t border-zinc-200 text-sm text-zinc-600 space-y-2">
            <div>
              No account?{' '}
              <Link to="/register" data-testid="to-register" className="font-bold text-[#002FA7] underline decoration-2 underline-offset-2">
                Register here
              </Link>
            </div>
            <div>
              Forgot your password?{' '}
              <Link to="/forgot-password" data-testid="to-forgot" className="font-bold text-[#002FA7] underline decoration-2 underline-offset-2">
                Reset it
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
